var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveSessions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,251.02c0,63.05,24.55,122.33,69.14,166.91c45.57,45.58,106.5,70.22,171.12,69.1 c61.57-1.07,120.5-26.36,163.77-70.17c40.89-41.4,64.66-95.28,67.73-153.02l23.38-3.08c5.06-0.73,7.44-6.66,4.28-10.68 l-55.35-74.02c-3.52-4.48-10.57-3.47-12.69,1.82l-39.64,86.75c-1.9,4.75,2.05,9.77,7.11,9.05l25.09-2.98 c-9.87,94.96-90.37,169.25-187.9,169.25c-104.58,0-190.33-86.96-188.9-191.53c1.4-102.97,85.6-186.31,188.9-186.31h0 c6.63,0,12-5.37,12-12V26.96c0-6.63-5.37-12-12-12h0c-63.08,0-122.4,24.59-166.98,69.21C24.78,128.49,0,188.37,0,251.02z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.14,211.99l87.37,76.28L353,162.96c8.72-9.63,7.89-24.53-1.85-33.13l-0.01-0.01 c-9.56-8.44-24.12-7.64-32.69,1.79l-82.95,91.25l-52.68-46c-9.7-8.47-24.44-7.47-32.91,2.23l0,0 C141.44,188.8,142.44,203.52,152.14,211.99z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSessions);
export default __webpack_public_path__ + "static/media/activeSessions.68e31b40.svg";
export { ForwardRef as ReactComponent };